import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialogRef } from '@angular/material/dialog';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
  FormArray,
} from '@angular/forms';
import { CorrespondenceActionPartyDto } from '@cradua/data';

export class ActionPartyMod extends CorrespondenceActionPartyDto {
  isSelected: string;
}

@Component({
  selector: 'mrsoftapps-correspondence-modal',
  templateUrl: './correspondence-modal.component.html',
  styleUrls: ['./correspondence-modal.component.css'],
})
export class CorrespondenceModalComponent implements OnInit {
  sortedItems: any[];
  filteredActionParties: ActionPartyMod[] = [];
  isNotifySelect = false;
  control = new FormControl(false);
  actionForm: FormGroup;
  correspondenceActionPartyFormArray: FormGroup;
  constructor(
    public dialogRef: MatDialogRef<CorrespondenceModalComponent>,
    @Inject(MAT_DIALOG_DATA) public modalData: any,
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    if (this.modalData.name === 'openCreateAction') {
      this.actionFormValidation();
    } else if (this.modalData.name === 'openActionParty') {
      if (
        this.modalData.selectedActionPartyIds.length > 0 &&
        this.modalData.actionParties.length > 0
      ) {
        this.filteredActionParties = this.modalData.actionParties.filter(
          (item) => this.modalData.selectedActionPartyIds.includes(item.id)
        );

        console.log(this.filteredActionParties);

        this.correspondenceActionPartyFormArray = this.fb.group({
          CorrespondenceActionParties: this.fb.array([]),
        });
        this.setCorrespondenceFalse();
      }
    }
  }

  setCorrespondenceTrue() {
    const control = this.correspondenceActionPartyFormArray.controls
      .CorrespondenceActionParties as FormArray;
    this.filteredActionParties.forEach((item) => {
      control.push(
        this.fb.group({
          CorrespondenceActionPartyName: item.CorrespondenceActionPartyName,
          isSelected: true,
          id: item.id,
        })
      );
    });
  }

  setCorrespondenceFalse() {
    const control = this.correspondenceActionPartyFormArray.controls
      .CorrespondenceActionParties as FormArray;
    this.filteredActionParties.forEach((item) => {
      control.push(
        this.fb.group({
          CorrespondenceActionPartyName: item.CorrespondenceActionPartyName,
          isSelected: false,
          id: item.id,
        })
      );
    });
  }

  clearFormArray = (formArray: FormArray) => {
    const control = this.correspondenceActionPartyFormArray.controls
      .CorrespondenceActionParties as FormArray;
    while (formArray.length !== 0) {
      control.removeAt(0);
    }
  };

  onCheckAll() {
    this.isNotifySelect = !this.isNotifySelect;
    // console.log('event ',this.isNotifySelect)
    if (this.isNotifySelect) {
      this.control.setValue(true);
      const control = this.correspondenceActionPartyFormArray.controls
        .CorrespondenceActionParties as FormArray;
      this.clearFormArray(control);
      this.setCorrespondenceTrue();
    } else {
      const control = this.correspondenceActionPartyFormArray.controls
        .CorrespondenceActionParties as FormArray;
      this.clearFormArray(control);
      this.setCorrespondenceFalse();
    }
  }

  closeModal() {
    this.dialogRef.close();
  }

  actionFormValidation() {
    this.actionForm = this.fb.group({
      ActionDescription: ['', Validators.required],
      ActionTitle: ['', Validators.required],
      RegisterId: [''],
      ActionViewerId: [''],
      Response: [''],
      Status: ['Pending'],
    });
  }

  /* Handle form errors in Angular 8 */
  public errorHandling = (control: string, error: string) => {
    return this.actionForm.controls[control].hasError(error);
  };

  submitAction(value) {
    this.dialogRef.close(value);
  }

  saveNotification(value) {
    this.dialogRef.close(value);
  }
}
